function Footer() {
    return <footer>
        <p className="text-center mt-8 text-xs shadow-inner py-4">2022 - Thomas Couacault &amp; Youën Ruaux</p>
    </footer>
}

export default Footer